
import { useState } from 'react';

export default function ContactForm() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus('idle');

        const formData = new FormData(e.currentTarget);

        // Formsubmit.co specific fields
        formData.append('_subject', 'Novo Contacto do Site - MM Carpintaria');
        formData.append('_template', 'table');
        formData.append('_captcha', 'false');

        try {
            const response = await fetch('https://formsubmit.co/ajax/mmcarpintaria2023@gmail.com', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setStatus('success');
                (e.target as HTMLFormElement).reset();
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error('Erro ao enviar formulário:', error);
            setStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section className="bg-gray-50 py-16">
            <div className="container mx-auto px-4">
                <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="p-8 md:p-12">
                        <div className="text-center mb-10">
                            <h2 className="text-3xl font-bold text-gray-900 mb-4">Peça o seu Orçamento Gratuito</h2>
                            <p className="text-gray-600">Preencha o formulário abaixo e entraremos em contacto brevemente.</p>
                        </div>

                        {status === 'success' ? (
                            <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg p-6 text-center animate-fade-in">
                                <i className="ri-checkbox-circle-line text-4xl mb-2 block"></i>
                                <p className="font-semibold text-lg">Mensagem enviada com sucesso!</p>
                                <p className="text-sm mt-1">Entraremos em contacto em breve.</p>
                                <button
                                    onClick={() => setStatus('idle')}
                                    className="mt-4 text-green-700 hover:text-green-900 underline text-sm"
                                >
                                    Enviar nova mensagem
                                </button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label htmlFor="name" className="text-sm font-medium text-gray-700">Nome Completo</label>
                                        <input
                                            type="text"
                                            name="Nome"
                                            id="name"
                                            required
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-mmcarpintaria-green/20 focus:border-mmcarpintaria-green transition-colors"
                                            placeholder="Seu nome"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label htmlFor="phone" className="text-sm font-medium text-gray-700">Telemóvel</label>
                                        <input
                                            type="tel"
                                            name="Telemóvel"
                                            id="phone"
                                            required
                                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-mmcarpintaria-green/20 focus:border-mmcarpintaria-green transition-colors"
                                            placeholder="Seu contacto"
                                        />
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label htmlFor="email" className="text-sm font-medium text-gray-700">Email</label>
                                    <input
                                        type="email"
                                        name="Email"
                                        id="email"
                                        required
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-mmcarpintaria-green/20 focus:border-mmcarpintaria-green transition-colors"
                                        placeholder="seu.email@exemplo.com"
                                    />
                                </div>

                                <div className="space-y-2">
                                    <label htmlFor="message" className="text-sm font-medium text-gray-700">Serviço Pretendido / Mensagem</label>
                                    <textarea
                                        name="Mensagem"
                                        id="message"
                                        required
                                        rows={4}
                                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-mmcarpintaria-green/20 focus:border-mmcarpintaria-green transition-colors resize-none"
                                        placeholder="Descreva o serviço que necessita..."
                                    ></textarea>
                                </div>

                                {status === 'error' && (
                                    <div className="bg-red-50 text-red-600 p-4 rounded-lg text-sm text-center">
                                        Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente ou contacte-nos diretamente.
                                    </div>
                                )}

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`
                                            inline-flex items-center justify-center px-8 py-4 
                                            bg-mmcarpintaria-green text-white font-bold uppercase tracking-widest text-sm rounded-lg
                                            transform transition-all duration-200 
                                            ${isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:bg-mmcarpintaria-green-dark hover:-translate-y-1 hover:shadow-lg'}
                                        `}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                A Enviar...
                                            </>
                                        ) : (
                                            <>
                                                Pedir Orçamento Grátis
                                                <i className="ri-arrow-right-line ml-2"></i>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        )}

                        <div className="mt-8 pt-8 border-t border-gray-100 text-center text-sm text-gray-500">
                            <p>Prefere falar connosco agora? Ligue <a href="tel:+351964759517" className="text-mmcarpintaria-green font-bold hover:underline">964 759 517</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
